import { c as _c } from "react/compiler-runtime";
import { FormInput, PrimaryButton } from '@systemeio/ui';
import { createTag } from 'modules/tags/api/tags-api';
import { TagCreateInterface, TagInterface } from 'modules/tags/types/tag-interface';
import { useState } from 'react';
import CreateModal, { CreateDataType } from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
export interface CreateNewTagModalProps {
  onCreate: (newTag: TagInterface) => Promise<void>;
}
interface ErrorsInterface {
  name: string;
}
const defaultErrors = {
  name: ''
};
export const CreateNewTagModal = t0 => {
  const $ = _c(23);
  const {
    onCreate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpened, setIsOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== onCreate) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        const {
          data: newTag
        } = await createTag({
          name: data?.name
        });
        await onCreate(newTag);
      }, setErrors);
    };
    $[0] = onCreate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCreateTag = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpened(false);
      setErrors(defaultErrors);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onClose = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsOpened(true);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.tag.create_tag_button.label");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <PrimaryButton onClick={t3}>{t4}</PrimaryButton>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      name: ""
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("dashboard.tag.title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== errors || $[12] !== t) {
    t8 = [{
      field: "name",
      onRender: (value, onChange) => <FormInput key="tag-name-create" label={t("dashboard.tag.tag_name")} placeholder={t("global.name")} value={value} onChange={e => onChange(e.target.value)} maxLength={256} error={errors.name} />
    }];
    $[11] = errors;
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["name"];
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isOpened || $[16] !== onCreateTag || $[17] !== t7 || $[18] !== t8) {
    t10 = <CreateModal opened={isOpened} onClose={onClose} defaultValues={t6} caption={t7} creatable={t8} onCreate={onCreateTag} requiredFields={t9} />;
    $[15] = isOpened;
    $[16] = onCreateTag;
    $[17] = t7;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};